module.exports = "https://www.gc-pro.gnp.com.mx/76d0f0ac01400e1246032d5a0665ab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/acceso-compartido/04.png
// module id = 998
// module chunks = 0 1